module.exports = __webpack_public_path__ + "static/media/lucero.bbd37695.webp";